export function generateLink(reportType, reportId, srcToken, brmId, thyFilter) {
    let baseUrl = "https://kuantumplus.rut.com.tr/";
    
    let returnUrl;
    if (reportType === "DASHBOARD") {
      returnUrl = `${baseUrl}auth/?scrtkn=${srcToken}&returnurl=${baseUrl}DashBoard/BI?VOUCHERNO=${reportId}&BRM_ID=${brmId}&T_HY_FILTER=${thyFilter}`;
    } else if (reportType === "REPORT") {
      returnUrl = `${baseUrl}auth/?scrtkn=${srcToken}&returnurl=${baseUrl}report?report=${reportId}&BRM_ID=${brmId}&T_HY_FILTER=${thyFilter}`;
    } 
    
    
    return returnUrl;
  }
  